export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'AirplayIcon',
    resource: 'R0',
    action: 'read',
  },
  {
    title: 'Second Page',
    route: 'second-page',
    icon: 'FileIcon',
    resource: 'R0',
    action: 'read',
  },
  {
    title: 'Dispo',
    route: 'DispositionList',
    icon: 'AlignRightIcon',
    resource: 'R600',
    action: 'read',
  },
  {
    title: 'Kontrolle',
    route: 'VoucherConfirm',
    icon: 'CheckCircleIcon',
    resource: 'R500',
    action: 'read',
  },
  {
    title: 'Kostenübersicht',
    route: 'TaxOffice',
    icon: 'DollarSignIcon',
    resource: 'R10',
    action: 'read',
  },
  {
    title: 'Kunden',
    route: 'customerList',
    icon: 'AlignLeftIcon',
    resource: 'R700',
    action: 'read',
  },
  {
    title: 'Rechnungen',
    route: 'BillingList',
    icon: 'DollarSignIcon',
    resource: 'R600',
    action: 'read',
  },
  {
    title: 'Adressen',
    route: 'AddressTemplate',
    icon: 'AlignJustifyIcon',
    resource: 'R0',
    action: 'read',
  },
  {
    title: 'Logs',
    route: 'Logs',
    icon: 'AlignJustifyIcon',
    resource: 'R10',
    action: 'read',
  },
  {
    title: 'Voucher',
    route: 'voucher',
    icon: 'FileIcon',
    resource: 'R500',
    action: 'read',
    children: [
      {
        title: 'Voucher liste',
        route: 'Voucherlist',
        icon: 'FileIcon',
        resource: 'R500',
        action: 'read',
      },
      {
        title: 'Neuer Voucher',
        route: 'clearVoucher',
        icon: 'FilePlusIcon',
        resource: 'R500',
        action: 'read',
      },
    ],
  },
  {
    title: 'Einstellungen',
    route: 'settings',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Flüge',
        route: 'FlightList',
        icon: 'BriefcaseIcon',
        resource: 'R200',
        action: 'read',
      },
      {
        title: 'Fahrer',
        route: 'Driver',
        icon: 'UserIcon',
        resource: 'R800',
        action: 'read',
      },
      {
        title: 'Fahrzeuge',
        route: 'Vehicle',
        icon: 'TruckIcon',
        resource: 'R820',
        action: 'read',
      },
      {
        title: 'Pushover',
        route: 'Pushover',
        icon: 'BellIcon',
        resource: 'R10',
        action: 'read',
      },
      {
        title: 'E-Mail Templates',
        route: 'MailTemplateList',
        icon: 'MailIcon',
        resource: 'R10',
        action: 'read',
      },
      {
        title: 'Berechtigungen',
        route: 'Users',
        icon: 'LockIcon',
        resource: 'R10',
        action: 'read',
      },
    ],
  },
]
